'use client';

import { TableColumnMapping, tableColumnMappingTag } from '@ni/nimble-components/dist/esm/table-column/mapping';
import { wrap } from '../../utilities/react-wrapper';

export { tableColumnMappingTag };
export { type TableColumnMapping };
export const NimbleTableColumnMapping = wrap(TableColumnMapping);
